import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddc53366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Geplante Baumaßnahme", -1))
const _hoisted_4 = { class: "content h-full max-h-full" }
const _hoisted_5 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben ", -1))
const _hoisted_9 = { class: "text-xs col-span-2 row-span-2" }
const _hoisted_10 = { class: "text-gray-500 text-xs" }
const _hoisted_11 = { class: "text-xs col-span-3" }
const _hoisted_12 = { class: "text-xs text-gray-500" }
const _hoisted_13 = { class: "text-xs col-span-3" }
const _hoisted_14 = { class: "text-xs text-gray-500" }
const _hoisted_15 = { class: "text-xs col-span-3" }
const _hoisted_16 = { class: "text-gray-500 text-xs" }
const _hoisted_17 = { class: "text-xs col-span-3" }
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = { class: "text-xs col-span-5" }
const _hoisted_20 = { class: "text-xs text-gray-500" }
const _hoisted_21 = { class: "text-xs col-span-6" }
const _hoisted_22 = { class: "text-xs text-gray-500" }
const _hoisted_23 = { class: "text-xs col-span-6" }
const _hoisted_24 = { class: "text-xs text-gray-500" }
const _hoisted_25 = { class: "text-xs col-span-6" }
const _hoisted_26 = { class: "text-xs text-gray-500" }
const _hoisted_27 = { class: "text-xs col-span-3" }
const _hoisted_28 = { class: "text-xs text-gray-500" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_30 = { class: "text-xs col-span-2 grid grid-cols-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Analyse ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-6 border-solid rounded-md whiteYellowBorderColor" }, "Analyseergebnisse", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, " Betroffene Flurstücke:", -1))
const _hoisted_34 = { class: "text-xs text-gray-500 col-span-6 grid grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_bauflaechen_footer = _resolveComponent("bauflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_tng_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["ba", "immobilie", "lang"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(" Art: "),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba,'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahme.baumassnahme-group.baumassnahmeart')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(" Masttyp: "),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getAuswahlLabel(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahme.baumassnahme-group.masttyp'
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(" Mastbild: "),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getAuswahlLabel(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahme.baumassnahme-group.mastbild'
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(" Arbeitsfläche Größe: "),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.ba,
              'rippistein-bauflaechen.allgemein-tab.allgemein-group.flaechengroesse'
            )['eingabeText']) + " " + _toDisplayString('\u{33A1} '), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createTextVNode(" Mast-Bauflächenkante: "),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.allgemein-group.abstand-mast-bauflaechenkante'
              )['eingabeText']) + " m", 1)
              ]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahme.baumassnahme-group.masthoehe-bekannt",
                label: "Masthöhe vorhanden",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(" Masthöhe: "),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahme.baumassnahme-group.masthoehe'
              )['eingabeText']) + " m", 1)
              ]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.seilzug-vorhanden",
                label: "Seilzug vorhanden",
                class: "col-span-8"
              }, null, 8, ["ba"]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.fundamentverstaerkung-vorhanden",
                label: "Fundamentverstärkung",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.fundamentverstaerkung-beschreibung'
              )['eingabeText']), 1)
              ]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.mastverstaerkung-vorhanden",
                label: "Mastverstärkung",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.mastverstaerkung-beschreibung'
              )['eingabeText']), 1)
              ]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-vorhanden",
                label: "Sonstiges",
                class: "col-span-2 text-xs"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-beschreibung'
              )['eingabeText']), 1)
              ]),
              _createVNode(_component_is_vorhanden_char_and_label, {
                ba: _ctx.ba,
                fragesPath: "rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-vorhanden",
                label: "Zusätzliche Maßnahmen:",
                class: "col-span-2"
              }, null, 8, ["ba"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-beschreibung'
              )['eingabeText']), 1)
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                'rippistein-bauflaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-art'
              )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "text-xs text-gray-500"
                  }, _toDisplayString(v), 1))
                }), 128))
              ]),
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
            _ctx.ba,
            'rippistein-bauflaechen.allgemein-tab.allgemein-group.betroffeneflurstuecke'
          ).getCurrentInput()?.split(';')?.sort(), (v, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "text-xs text-gray-500"
                  }, _toDisplayString(v), 1))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_bauflaechen_footer, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang,
            class: ""
          }, null, 8, ["ba", "immobilie", "lang"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}